<template>
  <div name="challengeevent" >

        <div class="w-12/12 h-80p  p-4  grid" v-bind:class="!isTimeWithCount ? 'grid-cols-1 w-12/12 pl-9' : ' grid-cols-2 gap-4'">

                <div class="boxit" v-bind:class="!isTimeWithCount ? 'h-20' : 'h-2/3'">
                
                   <div class="boxit-date text-purple-600 flex flex-row float-right cursor-pointer hover:bg-opacity-75 ">
                    <datetime v-model="eventDate" input-class="date-input" 
                     :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                     :auto=true ></datetime> <i class="fas fa-chevron-right pt-3 pr-3"></i>
                  </div>
                     <h3 class="boxit-header pl-4" v-bind:class="!isTimeWithCount ? 'border-0 mb-0 pb-1' : ''">Date  </h3>
                    <div class="w-10/12 mx-auto mt-4" v-if="isTimeWithCount">
                      <timer></timer>
                    </div>
                   
                </div>
                <div class="boxit h-2/3 pb-4 max-h-screen overflow-y-scroll" v-bind:class="!isTimeWithCount ? 'mt-4' : ''">
                  <div @click="restart"
                  class="text-purple-600 flex flex-row float-right cursor-pointer hover:bg-opacity-75 mt-2 pr-3 ">
                  <i class="fas fa-redo-alt pt-1 pr-3"></i> Restart Scores
                  </div>

                  <h3 class="boxit-header pl-2" >Scores</h3>
                  <table class="w-12/12 mb-6" :key="componentKey">
                    <tr v-for="pupil in pupils" :key="pupil.identifier" class="bg-white even:bg-gray-200">
                     

                        <template v-if="!isTimeWithCount">
                           <td class="text-sm"> <span class="font-bold">{{pupil.name}}</span> </td>
                          <td class="text-base text-purple-600 font-semibold text-right pb-2"  v-bind:class="isCounter ? 'w-4/12' : 'w-2/12'">
                          <doublePicker :value="0" :layout="layoutProp" class="p-0 m-0" v-if="isDoublePicker" 
                          @countChange="counterUpdated($event, pupil)"></doublePicker>
                           <counter :value="0"  class="p-0 m-0" v-else 
                           @countChange="counterUpdated($event, pupil)"></counter>
                          
                      </td>
                        </template>
                        <template v-else> 
                            <td class="text-sm"> <span class="font-bold">{{pupil.name}}</span> 

                      <div class="text-base text-purple-600 font-semibold text-right pb-2">
                          <doublePicker :value="0" :layout="layoutProp" class="p-0 m-0" v-if="isDoublePicker" 
                          @countChange="counterUpdated($event, pupil)"></doublePicker>
                           <counter :value="0"  class="p-0 m-0" v-else 
                           @countChange="counterUpdated($event, pupil)"></counter>
                         </div>
                          
                      </td>
                        </template>
                

                    </tr>
                  </table>
                </div>

        </div>

        <div class="w-10/12 mx-auto mt-5 ">
      <button @click="finish()"  class="button-purple h-16 w-full bg-green-400 ">Finish Challenge</button>
    </div>


  </div>
</template>

<script>
import moment from 'moment'
import { Datetime } from 'vue-datetime';

import { mapGetters } from 'vuex'
import { calendarYearList } from "@/assets/js/utils";

import { ChallengeService } from "@/services/challenge.service";

const savenotice = () => import('@/components/SaveNotice.vue')
const timer = () => import('@/components/challenges/BaseTimer.vue')
const doublePicker = () => import('@/components/helpers/DoublePicker.vue')
const counter = () => import('@/components/helpers/Counter.vue')

const Layouts = {COUNTER: 1, TIMEWITHCOUNT: 2, DISTANCE: 3, TIME: 4 }

export default {
  name: 'challengeevent',
   props: {
      pupils: {type: Array, required: true},
    },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    isCounter() {
      return this.challenge.layout_id === Layouts.COUNTER
    },
    isTimeWithCount() {
      return this.challenge.layout_id === Layouts.TIMEWITHCOUNT
    },
    isDoublePicker() {
       return [Layouts.TIME, Layouts.DISTANCE].includes(this.challenge.layout_id)
    },
    layoutProp() {
      return Layouts.TIME === this.challenge.layout_id ? 'time' : 'distance'
    }
  },
  data () {
    return {
      loading: true,
      school: this.$store.getters.school,
      challenge: this.$store.getters.challenge,
      errored: false,
      eventDate: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
      results: [],
      componentKey: 0,
    }
  },
  created() {

  },
  mounted () {
  },
  methods: {
    selectedChallengeImage() {
     // return require('@/assets/images/challenges/' + this.challenge.image_url.String + '.svg')
    },
    restart() {
      console.log("restart")
      this.componentKey += 1
    },
    failure(error) {
      console.log(error)
    },
    finish() {  
      const vm = this

      let calendarYear = calendarYearList().find((y) => y.current === true);

      vm.results.forEach((r, index) => {
        if (r.count > 0) {
          let payload = { 
            challenge_identifier: vm.challenge.identifier,
            register_identifier: r.register_identifier,
            result: r.count.toString(),
            calendar_schoolyear: calendarYear.value,
        }

        ChallengeService.addResult(payload)
          .then(response => {
            if (index == vm.results.length - 1) {
              this.$router.push({ name: 'ChallengeScoreboard' });
              window.scrollTo(0, 0);
            }
          })
          .catch((err) => { this.failure(err)})
        }
      });

    },
    counterUpdated(value, pupil) {
      if (this.results.length === 0) {
        this.results = this.pupils.map(p => (
        {
          register_identifier: p.identifier,
          count: 0
        }
      ))
      }
      

      var result = this.results.find(r => r.register_identifier === pupil.identifier)
       if (result != undefined) {
        result.count = value
       }
    }
  },
  components: {
    savenotice,
    timer,
        datetime: Datetime,
        doublePicker,
        counter
  }
}
</script>

<style>

.boxit {
  @apply p-4 pt-6 bg-white rounded-md shadow-lg;
}

.boxit-header {
  @apply font-bold text-purple-700 text-xl w-full border-solid border-b border-gray-200 pb-4 mb-4;
}

.boxit-date input {
  @apply text-purple-600 border-0 inline w-48 text-right cursor-pointer  !important;

}

.boxit-date input :hover {
  opacity: 0.7;
}

input[type="text"], input[type="password"], textarea {
  padding-top: 0rem;
  margin-top: 0rem;
}

</style>